(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7812);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_slicezone__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1620);
/* harmony import */ var nanoid__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3416);
/* harmony import */ var lodash_clonedeep__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3465);
/* harmony import */ var lodash_clonedeep__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_clonedeep__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _sm_resolver__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(894);
/* harmony import */ var _hooks_useUpdatePreviewRef__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3053);
/* harmony import */ var _utils_structuredData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3382);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8058);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5893);













var Layout = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(835), __webpack_require__.e(445), __webpack_require__.e(446)]).then(__webpack_require__.bind(__webpack_require__, 3446));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(3446)];
    }
  }
});

var Home = function Home(_ref) {
  var _page$data, _page$data2, _page$data$meta_keywo, _page$data3, _page$data3$meta_keyw, _page$data3$meta_keyw2, _page$data4;

  var page = _ref.page,
      header = _ref.header,
      footer = _ref.footer,
      preview = _ref.preview;
  (0,_hooks_useUpdatePreviewRef__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(preview, page.id);
  var metaTitle = (0,_utils_common__WEBPACK_IMPORTED_MODULE_8__/* .getMetaText */ .pN)((_page$data = page.data) === null || _page$data === void 0 ? void 0 : _page$data.meta_title, page.lang);
  var metaDescription = (0,_utils_common__WEBPACK_IMPORTED_MODULE_8__/* .getMetaText */ .pN)((_page$data2 = page.data) === null || _page$data2 === void 0 ? void 0 : _page$data2.meta_description, page.lang);
  var metaKeywords = (_page$data$meta_keywo = (_page$data3 = page.data) === null || _page$data3 === void 0 ? void 0 : (_page$data3$meta_keyw = _page$data3.meta_keywords) === null || _page$data3$meta_keyw === void 0 ? void 0 : (_page$data3$meta_keyw2 = _page$data3$meta_keyw.map(function (_ref2) {
    var word = _ref2.word;
    return word;
  })) === null || _page$data3$meta_keyw2 === void 0 ? void 0 : _page$data3$meta_keyw2.filter(Boolean)) !== null && _page$data$meta_keywo !== void 0 ? _page$data$meta_keywo : [];
  var metaAlternate = (0,_utils_common__WEBPACK_IMPORTED_MODULE_8__/* .getMetaAlternates */ .ab)({
    pages: [lodash_clonedeep__WEBPACK_IMPORTED_MODULE_3___default()(page)].concat((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(page.alternate_languages))
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(Layout, {
    header: header,
    footer: footer,
    resolver: _sm_resolver__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: (0,_utils_structuredData__WEBPACK_IMPORTED_MODULE_7__/* .getStructuredDataLogo */ .mV)(page.lang)
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("title", {
        children: metaTitle
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("meta", {
        property: "og:title",
        content: metaTitle
      }, "title"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("meta", {
        name: "description",
        content: metaDescription
      }), !!metaKeywords.length && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("meta", {
        name: "keywords",
        content: metaKeywords.join(', ')
      }), metaKeywords.map(function (word) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("meta", {
          property: "article:tag",
          content: word
        }, (0,nanoid__WEBPACK_IMPORTED_MODULE_11__/* .nanoid */ .x0)());
      }), metaAlternate.map(function (_ref3) {
        var lang = _ref3.lang,
            href = _ref3.href;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("link", {
          rel: "alternate",
          hrefLang: lang,
          href: href
        }, (0,nanoid__WEBPACK_IMPORTED_MODULE_11__/* .nanoid */ .x0)());
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(next_slicezone__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
      resolver: _sm_resolver__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
      slices: (_page$data4 = page.data) === null || _page$data4 === void 0 ? void 0 : _page$data4.slices
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Home);

/***/ }),

/***/ 3382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wx": function() { return /* binding */ getStructuredDataCluster; },
/* harmony export */   "i7": function() { return /* binding */ getStructuredVerticalPage; },
/* harmony export */   "mV": function() { return /* binding */ getStructuredDataLogo; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(352);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8058);



var getOrganization = function getOrganization(lang) {
  var langResolved = (0,_common__WEBPACK_IMPORTED_MODULE_1__/* .localePathResolver */ .px)(lang);
  return {
    type: 'Organization',
    url: "https://".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .HOST */ .M5).concat(langResolved),
    name: "Digital House",
    logo: "https://".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .HOST */ .M5, "/ar/assets/logoDH.jpg")
  };
};

var getStructuredDataLogo = function getStructuredDataLogo(lang) {
  var organization = getOrganization(lang);
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': organization.type,
    url: organization.url,
    logo: organization.logo
  });
};
var getStructuredDataCluster = function getStructuredDataCluster(lang, metaTitle, metaDescription) {
  var organization = getOrganization(lang);
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'Course',
    name: metaTitle,
    description: metaDescription,
    provider: {
      '@type': organization.type,
      name: organization.name,
      sameAs: organization.url
    }
  });
};
var getStructuredVerticalPage = function getStructuredVerticalPage(clusters, lang) {
  var organization = getOrganization(lang);
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: [clusters.map(function (cluster) {
      return {
        '@type': 'ListItem',
        position: clusters.indexOf(cluster),
        item: {
          '@type': 'Course',
          url: (0,_common__WEBPACK_IMPORTED_MODULE_1__/* .prismicLinkResolver */ .LT)(cluster, undefined, true),
          name: cluster.data.meta_title,
          description: cluster.data.meta_description,
          provider: {
            '@type': organization.type,
            name: organization.name,
            sameAs: organization.url
          }
        }
      };
    })]
  });
};

/***/ }),

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5006);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [106,909,970,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);